import { FetchDataResponse, GetListRequest, NextType } from '../types';

export enum ObjectStateType {
	JSON = 2,
	Number = 3,
	String = 4,
	Base64 = 5,
}

export interface InfoObject {
	name: string;
	desc: string;
	example: any;
}

export interface CreateObjectRequest {
	type: ObjectStateType;
	ttl: number | null;
	validity: number | null;
	versionDeep: number | null;
	info: InfoObject;
}

export interface ObjectResponse extends CreateObjectRequest {
	object: string;
}

export interface GetListSegmentRequest extends GetListRequest {
	path?: number;
}

export interface GetListObjectResponse extends NextType {
	objects: string[];
}

export interface GetListSegmentResponse extends NextType {
	segments: string[];
}

export type GetObjectResponse = FetchDataResponse<ObjectResponse>;
export type ListObjectsResponse = FetchDataResponse<GetListObjectResponse>;
export type ListSegmentsResponse = FetchDataResponse<GetListSegmentResponse>;
